import { LoadingStates } from '@zg-rentals/rental-manager-env';
import type { BillingPortalGuestPayState } from '../../hooks/useGuestPay';

export const TEST_DATA: BillingPortalGuestPayState = {
  accountHasAccessToInvoices: true,
  guestPaySessionKey: '123',
  paymentType: 'ACH',
  invoices: [
    {
      balance: 100,
      invoiceNumber: 'INV123456',
      accountName: 'Test Property',
      amountDue: 200,
      dueDate: { day: 1, month: 1, year: 2024 },
      invoiceId: '1234',
      serviceEnd: { day: 30, month: 1, year: 2024 },
      serviceStart: { day: 1, month: 1, year: 2024 },
      paymentSucceeded: false,
      selectedForPayment: false,
      invoiceAddress: { street: '123 Fake St.', unit: 'Suite 123' },
      invoiceTaxAmount: 0,
    },
    {
      balance: 200,
      invoiceNumber: 'INV123457',
      accountName: 'Test Property',
      amountDue: 200,
      dueDate: { day: 1, month: 1, year: 2024 },
      invoiceId: '1234',
      serviceEnd: { day: 30, month: 1, year: 2024 },
      serviceStart: { day: 1, month: 1, year: 2024 },
      paymentSucceeded: false,
      selectedForPayment: false,
      invoiceAddress: { street: '123 Fake St.', unit: 'Suite 123' },
      invoiceTaxAmount: 10,
    },
    {
      balance: 300,
      invoiceNumber: 'INV123458',
      accountName: 'Test Property',
      amountDue: 200,
      dueDate: { day: 1, month: 1, year: 2024 },
      invoiceId: '1234',
      serviceEnd: { day: 30, month: 1, year: 2024 },
      serviceStart: { day: 1, month: 1, year: 2024 },
      paymentSucceeded: false,
      selectedForPayment: false,
      invoiceAddress: { street: '123 Fake St.', unit: 'Suite 123' },
      invoiceTaxAmount: 0,
    },
  ],
  guestPayLoadingSessionState: LoadingStates.SUCCESS,
  selectedInvoices: new Set(['INV123456', 'INV123458', 'INV123458']),
  primaryInvoice: 'INV123456',
  accountNumber: 'ZRN-1234567-ZRN-1234567',
};
